'use client';

import { AiProficiencyPageLoadingSkeleton } from '@/domains/pages/ai-proficiency/ai-proficiency-page-loading';
import { pageKeyToSegmentKind, segmentKindLabel } from '@/domains/pages/ai-proficiency/utils/segment-api-payloads';
import type { NebulyPageKey } from '@/domains/pages/types';
import { capitalizeFirstLetter } from '@/utils/capitalize-first-letter';

/** Title of the scale card, kept identical to the loaded page so a reload does not flip it. */
function segmentScaleTitle(pageKey: NebulyPageKey): string {
  const kind = pageKeyToSegmentKind(pageKey);
  const noun = kind ? segmentKindLabel(kind) : 'segment';
  return `${capitalizeFirstLetter(noun)} proficiency scores`;
}

/**
 * The page shell renders `Loading` with no props, so each segment page gets its own
 * bound skeleton and the scale card can carry the right noun on a full reload.
 */
export function createAiProficiencySegmentPageLoadingSkeleton(pageKey: NebulyPageKey) {
  const title = segmentScaleTitle(pageKey);
  return function AiProficiencySegmentPageLoadingSkeleton() {
    return <AiProficiencyPageLoadingSkeleton showSegmentPicker segmentScaleTitle={title} />;
  };
}